import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
const PRIMARY_COLUMN_WIDTH = 65;
const SECONDARY_COLUMN_WIDH = 100 - PRIMARY_COLUMN_WIDTH;
/**
 * DescriptionListContainer
 */
export const descriptionListContainerStyles = ({ theme }) => css `
	word-break: break-word;
	hyphens: auto;

	& + & {
		margin-top: ${pxToRem(theme.spacing[300])};
	}
`;
export const DescriptionListContainer = styled.div `
	${descriptionListContainerStyles}
`;
/**
 * DescriptionListElement
 */
export const descriptionListElementStyles = ({ $dataColumnSizeIsSmall, $amountOfColumns, }) => {
    if ($amountOfColumns > 3 && process.env.NODE_ENV === 'development') {
        throw new Error(`You passed ${$amountOfColumns} column titles to columnTitles. The maximum amount of column titles is 3. Please update accordingly.`);
    }
    return css `
		margin-block: 0;
		display: flex;
		flex-wrap: wrap;

		${$dataColumnSizeIsSmall &&
        css `
			&& {
				${DescriptionListTerm},
				${DescriptionListColumnTitle}:first-of-type {
					flex-basis: 60%;
				}

				${DescriptionListDetails},
				${DescriptionListColumnTitle} {
					flex-basis: 20%;
				}
			}
		`}

		${$amountOfColumns === 3 &&
        css `
			&& {
				${DescriptionListColumnTitle} {
					&:not(:first-of-type) {
						flex-basis: 25%;
					}
				}
			}
		`}
	`;
};
export const DescriptionListElement = styled.dl `
	${descriptionListElementStyles}
`;
/**
 * DescriptionListTitle
 */
export const descriptionListLabelTitleStyles = ({ theme }) => css `
	margin-bottom: ${pxToRem(theme.spacing[100])};
	display: block;
`;
export const DescriptionListTitle = styled(Typography).attrs(() => ({
    tagName: 'h5',
    variant: 'list-title',
})) `
	${descriptionListLabelTitleStyles}
`;
/**
 * mixin
 */
export const descriptionMixinStyles = ({ theme }) => css `
	height: 100%;
	flex: 1 1 100%;
	padding-right: ${pxToRem(theme.spacing[300])};

	vertical-align: top;
	display: inline-flex;
	align-items: center;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		flex-basis: ${SECONDARY_COLUMN_WIDH}%;
	}
`;
/**
 * DescriptionListTerm
 */
export const descriptionListTermStyles = ({ theme, $hasMultipleColumns, }) => css `
	color: ${theme.colors.informative.textDescription};

	${$hasMultipleColumns &&
    css `
		&& {
			flex-basis: 50%;
		}
	`}
`;
export const DescriptionListTerm = styled(Typography).attrs(() => ({
    tagName: 'dt',
    variant: 'label-title',
})) `
	${descriptionMixinStyles}
	${descriptionListTermStyles}
`;
/**
 * DescriptionListColumnTitle
 */
export const descriptionListColumnTitleStyles = ({ theme }) => css `
	&& {
		margin-bottom: ${pxToRem(theme.spacing[100])};
		flex-basis: 50%;
	}
`;
export const DescriptionListColumnTitle = styled(Typography).attrs({
    tagName: 'dt',
    variant: 'label-title',
}) `
	${descriptionMixinStyles}
	${descriptionListColumnTitleStyles}
`;
/**
 * DescriptionListDetails
 */
export const descriptionListDetailsStyles = ({ theme, $amountOfColumns, $hasColumnTitles, }) => {
    if ($amountOfColumns > 2 && process.env.NODE_ENV === 'development') {
        throw new Error(`You passed ${$amountOfColumns} values to value in items[x]. The maximum amount is 2. Please update accordingly.`);
    }
    return css `
		height: 100%;
		flex: 1 1 100%;
		vertical-align: top;
		margin-left: 0;
		margin-bottom: ${$hasColumnTitles ? pxToRem(theme.spacing[100]) : pxToRem(theme.spacing[200])};
		display: inline-block;

		line-height: ${pxToRem(theme.typography.heading7['75LabelTitle'].lineHeight)};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			flex-basis: ${PRIMARY_COLUMN_WIDTH}%;
		}

		${$amountOfColumns === 1 &&
        css `
			&& {
				flex-basis: 50%;
			}
		`}

		${$amountOfColumns === 2 &&
        css `
			&& {
				flex-basis: 25%;
			}
		`}

	${(!$hasColumnTitles || !$amountOfColumns) &&
        css `
			&& {
				flex-basis: ${PRIMARY_COLUMN_WIDTH}%;
			}
		`}
	`;
};
export const DescriptionListDetails = styled(Typography).attrs(() => ({
    tagName: 'dd',
    variant: 'body-text',
})) `
	${descriptionListDetailsStyles}
`;
//# sourceMappingURL=description-list.styled.js.map